import React from 'react'
import { Box } from '@mui/material'
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Typography
} from '@material-ui/core'
import { FiberManualRecord } from '@material-ui/icons'

const SubjectSpecificDetails = ({ infoText }) => {
  const classes = useStyles()
  return (
    <Box className={classes.infoBox}>
      <Typography>{infoText}</Typography>
      <List className={classes.unorderedList}>
        <ListItem className={classes.listItem}>
          <ListItemIcon className={classes.listIcon}>
            <FiberManualRecord className={classes.dotIcon} />
          </ListItemIcon>
          <ListItemText>
            We kindly request you to fill out the form below to provide us with the necessary
            information.
          </ListItemText>
        </ListItem>
        <ListItem className={classes.listItem}>
          <ListItemIcon className={classes.listIcon}>
            <FiberManualRecord className={classes.dotIcon} />
          </ListItemIcon>
          <ListItemText>
            Click on the small information icon next to each field to learn more about its purpose
            and how it will be used to present your information to users during the event.
          </ListItemText>
        </ListItem>
      </List>
    </Box>
  )
}

export default SubjectSpecificDetails

const useStyles = makeStyles({
  infoBox: {
    padding: '16px',
    borderRadius: '8px',
    backgroundColor: '#e0f7fa'
  },
  listItem: {
    padding: '0px'
  },
  listIcon: {
    minWidth: '20px'
  },
  dotIcon: {
    fontSize: '12px'
  },
  unorderedList: {
    paddingBottom: '0px'
  }
})
